import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { getTermsAndCondition, setActiveStep } from "../../new-booking-form.slice";
import TAConditionCTA from "./TAConditionCTA";
import Loader from "../../../../components/Loader";
import { BOOKING_AS } from "../../../../config/constant";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./TermsAndConditon.scss";

const TermsAndCondition = ({ isPreview }) => {
  const { t } = useTranslation();
  const [termsAndCondition, setTermsAndCondition] = useState(null);
  const location = useLocation();
  const history = useHistory();
  const queryParams = new URLSearchParams(location.search);
  const projectNameFromUrl = queryParams.get("project-name");
  const { applicantData, activeStep, isLoading, enquiryDetails } = useSelector(
    (state) => state?.newBookingForm
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (projectNameFromUrl) return;

    if (enquiryDetails?.data?.ProjectName && enquiryDetails?.data?.projectBrandName) {
      dispatch(getTermsAndCondition(`/${enquiryDetails?.data?.ProjectName}`)
      )
        .unwrap()
        .then((data) => {
          setTermsAndCondition(data || {});
        })
        .catch(() => {
          setTermsAndCondition(null);
        });
    }
  }, [enquiryDetails, projectNameFromUrl]);

  useEffect(() => {
    if (projectNameFromUrl) {
      dispatch(getTermsAndCondition(`/${projectNameFromUrl}`))
        .unwrap()
        .then((data) => {
          setTermsAndCondition(data || {});
        })
        .catch(() => {
          setTermsAndCondition(null);
          history.push("/404");
        });
    }
  }, [projectNameFromUrl, dispatch, history]);

  useEffect(() => {
    if (applicantData?.noOfApplicants >= 1 && !applicantData?.applicant1) {
      if (applicantData?.bookingAs === BOOKING_AS.INDIVIDUAL) {
        dispatch(setActiveStep(0))
      } else {
        dispatch(setActiveStep(2))
      }
    }
    if (applicantData?.noOfApplicants >= 2 && !applicantData?.applicant2) {
      if (applicantData?.bookingAs === BOOKING_AS.INDIVIDUAL) {
        dispatch(setActiveStep(1))
      } else {
        dispatch(setActiveStep(3))
      }
    }
    if (applicantData?.noOfApplicants >= 3 && !applicantData?.applicant3) {
      if (applicantData?.bookingAs === BOOKING_AS.INDIVIDUAL) {
        dispatch(setActiveStep(2))
      } else {
        dispatch(setActiveStep(4))
      }
    }
    if (applicantData?.noOfApplicants >= 4 && !applicantData?.applicant4) {
      if (applicantData?.bookingAs === BOOKING_AS.INDIVIDUAL) {
        dispatch(setActiveStep(3))
      } else {
        dispatch(setActiveStep(5))
      }
    }
  }, [applicantData])

  const handlePrevious = () => {
    dispatch(setActiveStep(activeStep - 1));
  };

  return (
    <>
      {isLoading && <Loader isLoading={isLoading} />}
      {termsAndCondition?.termsConditions && (
        <div className={`TermsWrapper ${isPreview ? "applicantDetailsCard" : ""
          }`}
        >
          {isPreview ? (
            <h3 className="titlePersonalHD marginBottom16">
              {t("termsAndConditions.title") || "Terms & Conditions"}
            </h3>
          ) : (
            <div className="titleTerms">{t("termsAndConditions.title") || "Terms & Conditions"}</div>
          )}
          <div
            dangerouslySetInnerHTML={{
              __html: termsAndCondition?.termsConditions || "",
            }}
          />
          {isPreview ? null : <TAConditionCTA handlePrevious={handlePrevious} />}
        </div>
      )}
    </>
  );
};



TermsAndCondition.propTypes = {
  isPreview: PropTypes.bool,
};

export default TermsAndCondition;